import { Helmet } from 'react-helmet';
import useGtmContainerContext from '@gotombola/react-contexts/lib/hooks/useGtmContainerContext';

// noinspection JSUnusedLocalSymbols
export function GtmContainer({ id: forcedId }: GtmContainerProps) {
    const { id: contextualId = undefined } = useGtmContainerContext();
    const id = forcedId || contextualId;

    if (!id) return null;

    return (
        <Helmet>
            <script type='text/javascript'>{`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${id}');
            `}</script>
            <noscript>{`
                <iframe src="https://www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
            `}</noscript>
        </Helmet>
    );
}

export interface GtmContainerProps {
    id?: string;
}

// noinspection JSUnusedGlobalSymbols
export default GtmContainer;
